import { render } from "./ImportationError.vue?vue&type=template&id=cdbb0d9a&ts=true"
import script from "./ImportationError.vue?vue&type=script&lang=ts"
export * from "./ImportationError.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__